<!--

  Esta eh a landing page, com as historias em destaque e o mapa, entre
outras coisas.
  A sidebar funciona como uma drawer que fica sempre aberta.

@Author Chris
-->

<template>
  <div class="page-container">
    <md-app class="viewport">
      <md-app-toolbar class="md-primary navbar" md-elevation="0">
        <navbar />
      </md-app-toolbar>
      <md-app-content class="map">
        <mapview
          class="mapview"
          :class="{ 'shortenedMap': show && !useModal }"
          :createOn="show"
          @createChapter="show = true"
        />
        <create-modal
          v-if="useModal"
          :createOn="show"
          :place="place"
          :showMinimap="true"
          @close="show = $event"
        />
        <div v-else v-show="show" class="createSidebar">
          <md-button @click="show = false" class="closeBtn">X</md-button>
          <create :place="place" />
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import bus from "@/api/bus"
import navbar from "../toolbar/navbar.vue";
import mapview from "../content/mapview.vue";
import create from "../content/create";
import createModal from "@/components/shared/chapter/createModal";

export default {
  name: "Home",
  data: () => ({
    show: false,
    place: null
  }),
  components: {
    navbar,
    mapview,
    createModal,
    create
  },
  computed: {
    useModal() {
      return window.innerWidth < 850;
    }
  },
  mounted() {
    bus.on.place(place => this.place = place);
    bus.on.clearPlace(() => this.place = null);
  },
  metaInfo: {
    title: "Home",
    meta: [
      {name: "robots", content: "noindex"},
      {name: "description", content: "Página principal."},
      {rel: "canonical", content: "https://www.chapstory.com/home"},
    ]
  }
};
</script>

<style lang="scss" scoped>
html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.viewport {
  height: 100vh;
}

.navbar {
  max-height: auto;
}

.map {
  padding: 0;
}

.mapview {
  display: inherit;
  position: absolute;
  height: calc(100vh - 50px);
}

.createSidebar {
  display: block;
  position: absolute;
  max-width: 450px;
  overflow: auto;
  height: calc(100% - 50px);
  right: 0;
  z-index: 3;
}

.closeBtn {
  position: absolute;
  right: 0;
}

.shortenedMap {
  width: calc(100vw - 450px);
}

.md-toolbar,
.md-toolbar-row,
.md-app-toolbar,
.md-app-toolbar-row {
  width: 100%;
  min-height: 50px !important;
  display: flex;
  align-items: center;
  align-content: center;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: opacity, background-color, box-shadow, transform, color,
    min-height;
  will-change: opacity, background-color, box-shadow, transform, color,
    min-height;
}

@media (max-width: 450px) {
  html,
  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .viewport {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  // .mapview {
  //   bottom: 0;
  //   height: calc(100vh - 65px);
  // }
}
</style>
